var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehanceLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.125H21.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 11.625H8.4375C9.28288 11.625 10.0936 11.9608 10.6914 12.5586C11.2892 13.1564 11.625 13.9671 11.625 14.8125C11.625 15.6579 11.2892 16.4686 10.6914 17.0664C10.0936 17.6642 9.28288 18 8.4375 18H2.625V6H7.3125C8.05842 6 8.77379 6.29632 9.30124 6.82376C9.82868 7.35121 10.125 8.06658 10.125 8.8125C10.125 9.55842 9.82868 10.2738 9.30124 10.8012C8.77379 11.3287 8.05842 11.625 7.3125 11.625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.25H22.5C22.5 13.5083 22.2801 12.7833 21.868 12.1666C21.456 11.5499 20.8703 11.0693 20.1851 10.7855C19.4998 10.5016 18.7458 10.4274 18.0184 10.5721C17.291 10.7168 16.6228 11.0739 16.0984 11.5984C15.5739 12.1228 15.2168 12.791 15.0721 13.5184C14.9274 14.2458 15.0016 14.9998 15.2855 15.6851C15.5693 16.3703 16.0499 16.956 16.6666 17.368C17.2833 17.7801 18.0083 18 18.75 18C19.3184 18.0026 19.8798 17.8743 20.3906 17.625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceLogo);
export default __webpack_public_path__ + "static/media/behance-logo.3820c992a241e73d5cc2a04e94f01b1e.svg";
export { ForwardRef as ReactComponent };